import { cn } from '../lib/utils';

// Logotipo Compra Agora recriado em SVG (sacola + carrinho) + wordmark.
// `theme="dark"` usa "AGORA" branco para legibilidade sobre superfícies navy.

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="ca-bag" x1="7" y1="7" x2="33" y2="37" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EC0A6F" />
          <stop offset="1" stopColor="#E11019" />
        </linearGradient>
      </defs>
      {/* alça da sacola */}
      <path
        d="M14 13.5C14 10.2 16.7 7.5 20 7.5s6 2.7 6 6"
        stroke="#E11019"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      {/* corpo da sacola */}
      <path
        d="M8.8 12.5h22.4a2 2 0 0 1 1.99 2.2l-1.62 17.8A4 4 0 0 1 27.58 36H12.42a4 4 0 0 1-3.98-3.5L6.81 14.7a2 2 0 0 1 1.99-2.2Z"
        fill="url(#ca-bag)"
      />
      {/* carrinho de compras */}
      <g stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13.5 17.5h2l1.6 8.2h8.1l1.5-6.1H16.2" fill="none" />
      </g>
      <circle cx="17.6" cy="28.4" r="1.35" fill="#fff" />
      <circle cx="24.6" cy="28.4" r="1.35" fill="#fff" />
    </svg>
  );
}

export function Logo({
  variant = 'full',
  theme = 'light',
  className,
}: {
  variant?: 'full' | 'mark';
  theme?: 'light' | 'dark';
  className?: string;
}) {
  if (variant === 'mark') {
    return <LogoMark className={cn('h-9 w-9', className)} />;
  }
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <LogoMark className="h-9 w-9 shrink-0" />
      <div className="leading-[0.95]">
        <div className="text-[15px] font-extrabold tracking-tight text-brand-red">COMPRA</div>
        <div className={cn('text-[15px] font-extrabold tracking-tight', theme === 'dark' ? 'text-white' : 'text-navy')}>
          AGORA
        </div>
      </div>
    </div>
  );
}
